module.exports = __webpack_public_path__ + "img/public.29df0e84.svg";